import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/more-horizontal.svg";
var MoreHorizontalSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  MoreHorizontalSolid_default as default
};
